import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { EpaApi } from '../../../services'
import { WaterTestParameter, WaterTestParamsState } from '../waterTestParams.slice'





export const fetchWaterTestParamsAsync = createAsyncThunk<
  WaterTestParameter[],
  void | {options?:AxiosRequestConfig}
>(
  'waterTestParams/fetchParameters',
  async ( {options = {}} = {}, { rejectWithValue }) => {
    try {

      const response = await EpaApi.getAnalyteParameters(options) as AxiosResponse<any>;
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Unexpected error occurred",
          errors: []
        }
      );
    }
  }
);

export const fetchWaterTestParamsAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterTestParamsState>
) => {
  builder.addCase(fetchWaterTestParamsAsync.pending, (state) => {
    state.loading = true;
    state.success = false;
    state.error = null;
  })
  builder.addCase(
    fetchWaterTestParamsAsync.fulfilled,
    (state, action) => {
      state.data = action.payload
      state.loading = false;
      state.success = true;
      state.error = null;

    }
  )
  builder.addCase(
    fetchWaterTestParamsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  )
}